<div class="wrapper">
  <div class="field">
    <ng-container #fieldComponent></ng-container>
  </div>

  <span *ngIf="getViewOnlyMode(field) || formState._mode === 'view'" [id]="field.id+'-view'">{{ field.formControl.value
    }}</span>
</div>